import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { useQuery } from '@tanstack/react-query'

export const useMembersDataQuery = (params: { time_zone?: string }) => {
  const membersDataQuery = useQuery({
    queryKey: ['useMembersDataQuery'],
    queryFn: async () => {
      const { data } = await MembershipsCreatorApiClient.getMembersData(params)

      return data
    },
    enabled: false,
  })

  return {
    membersDataQuery,
  }
}
